
import { MOCK_SITE_SAMPLE_IDS } from "./constants";


export const getSiteDetails = (site) => {

  switch (site) {
    case MOCK_SITE_SAMPLE_IDS.optimisation_amber:
      return optimisationAmberSpikeDetails;
    case MOCK_SITE_SAMPLE_IDS.optimisation_amber_solar_topup:
      return optimisationAmberTopupDetails;
    case MOCK_SITE_SAMPLE_IDS.optimisation_tou:
      return optimisationTouDetails;
    case MOCK_SITE_SAMPLE_IDS.optimisation_tou_solar_topup:
      return optimisationTouTopupDetails;
    case MOCK_SITE_SAMPLE_IDS.optimisation_tou_ev:
      return optimisationTouEvDetails;
    default:
      return getDefaultSiteDetails()
  }

};

const optimisationAmberSpikeDetails = {
  id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
  serial: "EB0010100001",
  reserved: 0,
  timestamp: 1742645652,
  solar: 0,
  grid: -3394,
  battery: 4975,
  hotwater: 0,
  ev: 0,
  ev_status: "charging",
  soc: 73.1194,
  backup: false,
  grid_present: true,
  online: true,
  ethernet: 0,
  modem: 2,
  wifi: 5,
  boost_id: null,
  storm_id: null,
  price_import: 13.1472242,
  price_export: -11.886568,
}

const optimisationAmberTopupDetails = {
  id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
  serial: "EB0010100001",
  reserved: 0,
  timestamp: 1742645652,
  solar: 3846,
  grid: 2442,
  battery: -4588,
  hotwater: 0,
  ev: 0,
  ev_status: "charging",
  soc: 44.15,
  backup: false,
  grid_present: true,
  online: true,
  ethernet: 0,
  modem: 2,
  wifi: 5,
  boost_id: null,
  storm_id: null,
  price_import: 0.0523842,
  price_export: 0.017832,
}


const optimisationTouDetails = {
  id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
  serial: "EB0010100001",
  reserved: 0,
  timestamp: 1742645652,
  solar: 0,
  grid: 5762,
  battery: -4997,
  hotwater: 0,
  ev: 0,
  ev_status: "charging",
  soc: 78.204,
  backup: false,
  grid_present: true,
  online: true,
  ethernet: 0,
  modem: 2,
  wifi: 5,
  boost_id: null,
  storm_id: null,
  price_import: 0.16,
  price_export: -0.05,
}


const optimisationTouTopupDetails = {
  id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
  serial: "EB0010100001",
  reserved: 0,
  timestamp: 1742645652,
  solar: 1564,
  grid: 4710,
  battery: -4695,
  hotwater: 0,
  ev: 0,
  ev_status: "charging",
  soc: 81.6885,
  backup: false,
  grid_present: true,
  online: true,
  ethernet: 0,
  modem: 2,
  wifi: 5,
  boost_id: null,
  storm_id: null,
  price_import: 0.08405,
  price_export: -0.02,
}


const optimisationTouEvDetails = {
  id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
  serial: "EB0010100001",
  reserved: 0,
  timestamp: 1742645652,
  solar: 727,
  grid: 12106,
  battery: -4771,
  hotwater: 0,
  ev: 6578,
  ev_status: "charging",
  soc: 82.4629,
  backup: false,
  grid_present: true,
  online: true,
  ethernet: 0,
  modem: 2,
  wifi: 5,
  boost_id: null,
  storm_id: null,
  price_import: 0.0,
  price_export: -0.05,
}

let counter = 1;
let index = 0;

const getDefaultSiteDetails = () => {

  const data = siteDetailsArray[index];

  index = index + 1;
  if (index >= siteDetailsArray.length) {
    index = 0;
  }
  counter = counter + 1;

  return data;
}

const siteDetailsArray = [
  {
    id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
    serial: "EB0010100001",
    reserved: 0,
    timestamp: 1742645652,
    solar: 7800,
    grid: 1030,
    battery: -4895,
    hotwater: 1330,
    ev: 2400,
    ev_status: "charging",
    soc: 66,
    backup: false,
    grid_present: true,
    online: true,
    ethernet: 0,
    modem: 2,
    wifi: 5,
    boost_id: null,
    storm_id: null,
    price_import: 0.36016,
    price_export: -0.28135,
  },
  {
    id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
    serial: "EB0010100001",
    reserved: 0,
    timestamp: 1742645712,
    solar: 7900,
    grid: 0,
    battery: -4595,
    hotwater: 0,
    ev: 2500,
    ev_status: "charging",
    soc: 66,
    backup: false,
    grid_present: true,
    online: true,
    ethernet: 0,
    modem: 2,
    wifi: 5,
    boost_id: null,
    storm_id: null,
    price_import: 0.36016,
    price_export: -0.28135,
  },
  {
    id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
    serial: "EB0010100001",
    reserved: 0,
    timestamp: 1742645772,
    solar: 7900,
    grid: 0,
    battery: -4595,
    hotwater: 0,
    ev: 2300,
    ev_status: "charging",
    soc: 68,
    backup: false,
    grid_present: true,
    online: true,
    ethernet: 0,
    modem: 2,
    wifi: 5,
    boost_id: null,
    storm_id: null,
    price_import: 0.36016,
    price_export: -0.28135,
  },
  {
    id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
    serial: "EB0010100001",
    reserved: 0,
    timestamp: 1742645832,
    solar: 7900,
    grid: 0,
    battery: -4295,
    hotwater: 0,
    ev: 2400,
    ev_status: "charging",
    soc: 69,
    backup: false,
    grid_present: true,
    online: true,
    ethernet: 0,
    modem: 2,
    wifi: 5,
    boost_id: null,
    storm_id: null,
    price_import: 0.36016,
    price_export: -0.28135,
  },
];
